/** PARTNER_SPEC_URL is the published Partner API document (FR-56). */
export const PARTNER_SPEC_URL = "/api/v1/partner/openapi.json";
